import { Link } from 'react-router-dom';
import LandingUpdatesSection from '../components/updates/LandingUpdatesSection';
import { useAuthStore } from '../store/authStore';
import { useCompanyStore } from '../store/companyStore';
import './LandingPage.css';

function LandingPage() {
  const isAuthenticated = useAuthStore((s) => s.isAuthenticated);
  const hasCompany = useCompanyStore((s) => s.hasCompany);

  const enterTo = isAuthenticated ? (hasCompany ? '/app' : '/companies') : '/login';
  const enterLabel = isAuthenticated ? (hasCompany ? '워크스페이스 열기' : '회사 선택') : '로그인';

  return (
    <div className="ll-landing">
      <header className="ll-landing__nav">
        <Link to="/" className="ll-landing__brand" aria-label="라인로그(Linelog) 홈">
          <em>Line</em>log
        </Link>
        <div className="ll-landing__nav-actions">
          <a href="#updates" className="ll-landing__nav-link">
            업데이트 내역
          </a>
          <Link to={enterTo} className="ll-landing__nav-login">
            {enterLabel}
          </Link>
        </div>
      </header>

      <section className="ll-landing__hero" aria-label="소개">
        <div className="ll-landing__hero-copy">
          <p className="ll-landing__brand-mark">
            <em>Line</em>log
            <span className="ll-landing__brand-ko">라인로그</span>
          </p>
          <h1 className="ll-landing__headline">
            제조 ERP · 전자결재
            <br />
            사내문서를 한곳에서
          </h1>
          <p className="ll-landing__lead">
            라인로그는 품질검사·부적합·공문서·기안·회의록·전자결재·PDF까지, 중소 제조 현장
            기록을 심사 문서로 이어가는 ERP 워크스페이스입니다.
          </p>
          <div className="ll-landing__cta">
            <Link to={enterTo} className="ll-landing__cta-primary">
              {enterLabel}
            </Link>
            {!isAuthenticated ? (
              <Link to="/login" className="ll-landing__cta-ghost">
                카카오로 시작하기
              </Link>
            ) : null}
          </div>
        </div>

        <div className="ll-landing__hero-visual" aria-hidden="true">
          <div className="ll-landing__plane">
            <div className="ll-landing__plane-grid" />
            <div className="ll-landing__sheet ll-landing__sheet--a">
              <span>인수검사</span>
              <strong>적합</strong>
            </div>
            <div className="ll-landing__sheet ll-landing__sheet--b">
              <span>NCR</span>
              <strong>외관 · 파레토</strong>
            </div>
            <div className="ll-landing__sheet ll-landing__sheet--c">
              <span>전자결재 PDF</span>
              <strong>제출 준비 완료</strong>
            </div>
          </div>
        </div>
      </section>

      <section className="ll-landing__section" id="erp" aria-labelledby="erp-heading">
        <h2 id="erp-heading">제조에 맞춘 ERP 흐름</h2>
        <p>
          계약·발주·재고·생산일보까지 회사 단위로 연결됩니다. 무거운 전사 ERP 대신, 현장과
          품질에 필요한 기능을 빠르게 쓸 수 있습니다.
        </p>
      </section>

      <section className="ll-landing__section ll-landing__section--alt" id="docs" aria-labelledby="docs-heading">
        <h2 id="docs-heading">사내문서와 전자결재</h2>
        <p>
          라인로그에서 공문서·기안·회의록·품질문서를 작성하고 결재선으로 승인합니다. 승인된
          문서는 회사 로고와 결재란이 들어간 PDF로 내려받아 고객사·인증 심사에 바로 제출할 수
          있습니다.
        </p>
      </section>

      <section className="ll-landing__section" id="quality" aria-labelledby="quality-heading">
        <h2 id="quality-heading">품질 흐름이 끊기지 않습니다</h2>
        <p>
          인수·중간·제품검사에서 나온 부적합이 NCR로 이어지고, QC 분석으로 불량 유형과 원인을
          바로 확인합니다.
        </p>
      </section>

      <section className="ll-landing__section ll-landing__section--alt" id="workspace" aria-labelledby="workspace-heading">
        <h2 id="workspace-heading">회사 단위로 안전하게</h2>
        <p>
          설비·안전·교육·품질문서를 회사 워크스페이스에서 함께 운영합니다. 권한과 결재선은
          조직에 맞게 나눕니다.
        </p>
        <Link to={enterTo} className="ll-landing__cta-primary ll-landing__cta-inline">
          {enterLabel}
        </Link>
      </section>

      <LandingUpdatesSection />

      <footer className="ll-landing__footer">
        <div className="ll-landing__footer-brand">
          <Link to="/" className="ll-landing__brand ll-landing__brand--sm">
            <em>Line</em>log
          </Link>
          <span>라인로그 · 제조 ERP · 전자결재 · 사내문서</span>
        </div>
        <p className="ll-landing__footer-contact">
          문의사항은{' '}
          <a href="mailto:ksg04001@daum.net">ksg04001@daum.net</a>
          으로 연락해 주세요.
        </p>
      </footer>
    </div>
  );
}

export default LandingPage;
